if (!customElements.get('cart-notes')) {
  class CartNotes extends HTMLElement {
    connectedCallback() {
      this.notes = this.querySelector('#mini-cart__notes');

      // accordion markup (ktechs): plain details/summary, explicit save button
      const save = this.querySelector('[data-note-save]');
      if (save) {
        save.addEventListener('click', (e) => {
          e.preventDefault();
          this.saveNotes();
          const details = this.querySelector('details');
          if (details) details.open = false;
        });
        return;
      }

      // legacy slide-up overlay markup
      this.toggle = this.querySelector('.order-note-toggle');
      this.content = this.querySelector('.order-note-toggle__content');

      if (!this.toggle || !this.content) return;

      this.toggle.addEventListener('click', () => {
        this.content.classList.add('active');
      });

      this.content.addEventListener('click', (e) => {
        if (e.target.closest('.button, .order-note-toggle__content-overlay')) {
          this.content.classList.remove('active');
          this.saveNotes();
        }
      });
    }

    saveNotes() {
      const request = fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          note: this.notes.value
        })
      });

      // shopify:cart:note-update — /cart/update.js responds with the full cart
      const SE = window.Shopify && window.Shopify.StandardEvents;
      if (SE) {
        publishStandardEvent('CartNoteUpdateEvent', {
          note: this.notes.value,
          promise: request
            .then((response) => response.json())
            .then((cart) => ({ cart: cart && cart.token ? SE.CartNoteUpdateEvent.createCartFromAjaxResponse(cart) : null }))
        }, this);
      }
    }
  }
  customElements.define('cart-notes', CartNotes);
}
